import { render, staticRenderFns } from "./CFormInput.vue?vue&type=template&id=53a56b0a&"
import script from "./CFormInput.vue?vue&type=script&lang=js&"
export * from "./CFormInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports